module.exports = __webpack_public_path__ + "static/media/sunset-investing-screenshot-9.a1c56e1b.jpg";